//libs
import React from 'react';

//styles
import { ProductsContainer, Product } from './styles';

//helpers
import { transfromViewSimilarData } from './helpers';

const ProductRenderer = ({ products }: Listing.IProduct[]) => {
  return (
    <ProductsContainer>
      {products.map((item, i) => {
        return <Product item={transfromViewSimilarData(item)} key={`view-similar-product-${item.id || i}`} />;
      })}
    </ProductsContainer>
  );
};

export default ProductRenderer;
